import { Col as AntdCol } from "antd"

const Col = props => {
  return <AntdCol {...props} />
}

export default Col
